import styled from 'styled-components';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Captions } from 'components/Typography';

export const StyledBreadcrumbs = styled(Breadcrumbs)`
  && {
    svg {
      color: #ffffff;
      opacity: 0.56;
    }
    li {
      margin: 0;
    }
    h6 {
      margin: 0;
      font-weight: 500;
    }
  }
`;

export const StyledDiv = styled.div`
  cursor: pointer;
`;

export const StyledRootCaption = styled(Captions)`
  && {
    color: #ffffff;
    opacity: 0.56;
  }
`;

export const StyledElementCaption = styled(Captions)`
  && {
    color: #ffffff;
    opacity: 0.87;
  }
`;
